import { css } from "@emotion/react"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const containerHidden = css`
  margin: 0;
  border: none;
  max-height: 0px;
`

export const container = css`
  display: flex;
  justify-content: flex-start;
  background-color: ${colorsCP['neutral-00']};
  margin: 32px 0 0;
  border: 1px solid  ${colorsCP['blue-40']};
  border-radius: 4px;
  overflow: hidden;
  max-height: 250px;
  transition: max-height 0.5s ease;


  ${above["m"]} {
    display: none;
  }

  .cp-btn {
    margin-top: 14px;
    padding: 12px 24px;
    font-family: "Source Sans Pro",sans-serif;
    font-size: 16px;
    font-weight: 600;
  }
`

export const modalContainer = css`
  ${above["m"]} {
    display: none;
  }
`

export const modalContainerHidden = css`
  opacity: 0;
  visibility: hidden;
`

export const modal = css`
  justify-content: flex-end;
  flex-direction: row-reverse;
  margin: 0 16px 0;
  border-radius: 8px;
  overflow: hidden;
`

export const image = css`
  display: flex;
  justify-content: center;

  ${above["m"]} {
    display: block;
  }
`
export const figure = css`
  display: flex;
  justify-content: space-between;
  width: 140px;
  align-items: flex-end;

  img {
    width: auto;
  }
`
export const figureModal = css`
  justify-content: flex-end;
  width: 150px;
`

export const data = css`
  padding: 16px 16px 16px 0 ;
`
export const title = css`
  font-size: 16px;
  line-height: 28px;
  color: ${colorsCP['neutral-70']};
`

export const subtitle = css`
  &.cp-text {
    margin-top: 8px;
    font-weight: 400;
  }
`
